const toCamel = (s) => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1
      .toUpperCase()
      .replace("-", "")
      .replace("_", "")
  })
}

// eslint-disable-next-line
const isArray = function (a) {
  return Array.isArray(a)
}

// eslint-disable-next-line
const isObject = function (o) {
  return o === Object(o) && !isArray(o) && typeof o !== "function"
}

// eslint-disable-next-line
const keysToCamel = function (o) {
  if (isObject(o)) {
    // eslint-disable-next-line
    const n = {}
    
    Object.keys(o).forEach((k) => {
      n[toCamel(k)] = keysToCamel(o[k])
    })
    
    return n
  } else if (isArray(o)) {
    // eslint-disable-next-line
    return o.map((i) => {
      return keysToCamel(i)
    })
  }
  
  return o
}


export {
  keysToCamel
}